import { UIHeading1, UIHeading4 } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './HintQuestions.css';

interface IHintQuestionsProps {
  redesigned?: boolean;
  // удалить проп после раскатки экспа, стили привязанные к пропу оставить
  commercialRedesigned?: boolean;
}

export const HintQuestions: React.FC<IHintQuestionsProps> = ({
  children,
  redesigned = false,
  commercialRedesigned = false,
}) => {
  const Heading = redesigned ? UIHeading1 : UIHeading4;

  return (
    <div
      className={classNames(
        styles['container'],
        redesigned && styles['container--redesigned'],
        commercialRedesigned && styles['container--redesigned-commercial'],
      )}
    >
      <Heading>Напишите автору</Heading>
      <div className={styles['hints-container']}>{children}</div>
    </div>
  );
};
